module.exports = __webpack_public_path__ + "img/growthAbility1.89d70a43.png";